import { useGlobalState } from "piral-core";
import { ReactNode } from "react";
import { getTheme } from "../services/teams";
import { FluentProvider } from "@fluentui/react-components";

export type ShellProvidersProps = {
  children: ReactNode;
};

const ShellProviders: React.FC = ({ children }: ShellProvidersProps) => {
  const shellData = useGlobalState((x) => x.shellData);
  console.log("Global state inside ShellLayout");

  const theme = getTheme(shellData.theme);

  return <FluentProvider theme={theme}>{children}</FluentProvider>;
};

export default ShellProviders;
